import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-768e4231"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ユーザ一覧 ")
const _hoisted_3 = {
  key: 1,
  class: "admin-banner"
}
const _hoisted_4 = {
  key: 2,
  class: "px-2"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" アカウント ")

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import { useNicotto } from '@/plugins/nicotto'
import IconUsers from './ui/IconUsers.vue'
import IconUserGear from './ui/IconUserGear.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAuth',
  setup(__props) {

const router = useRouter()
const store = useStore()
const nicotto = useNicotto()

const user = computed(() => store.state.user)
const municipality = computed(() => store.state.municipality)
const isAdmin = computed(() => store.getters.isAdmin)

const signout = async() => {
  await nicotto.auth.signOut()
  router.push('/signin')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isAdmin))
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/users",
          class: "btn btn-sm btn-light me-2",
          role: "button"
        }, {
          default: _withCtx(() => [
            _createVNode(IconUsers),
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(isAdmin) && _unref(municipality))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(IconUserGear),
          _createTextVNode(" " + _toDisplayString(_unref(municipality)?.name), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(user))
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(user).name) + "さん", 1))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_router_link, {
      to: "/account",
      class: "btn btn-sm btn-outline-light me-2",
      role: "button"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 512), [
      [_vShow, ! _unref(isAdmin)]
    ]),
    _createElementVNode("button", {
      class: "btn btn-sm btn-outline-light",
      onClick: signout
    }, " ログアウト ")
  ]))
}
}

})